export enum SubmissionCommunicationEntity {
  submissionsCommunicationsCertificates = "submissionsCommunicationsCertificates",
  submissionsCommunicationsLetters = "submissionsCommunicationsLetters",
}
